export function createSldpPlayer(customOption: SldpOption) {
  let defaultOption = {
    pause_timeout: 60,
    reconnects: 120,
    width: "parent",
    height: "parent",
    controls: false,
    muted: false,
    autoplay: true,
    adaptive_bitrate: false,
    offset: 1600,
    buffering: 400,
    latency_tolerance: 2000,
  }

  return window.SLDP.init({ ...defaultOption, ...customOption })
}

interface SldpOption {
  video_element: string
  container?: string
  stream_url?: string
  adaptive_bitrate?: boolean
  offset?: number
  buffering?: number
  latency_tolerance?: number
  pause_timeout?: number
  sync_buffer?: number
  reconnects?: number
  width?: string
  height?: string
  controls?: boolean
  autoplay?: boolean
  muted?: boolean
}

interface SldpPlayer {
  type?: string
  stop: Function
  start: Function
  play: Function
  pause: Function
  setVolume?: Function
  setStreamURL: Function
  setCallbacks?: Function
  destroy?: Function
  getCurrentStream?: Function
}

export interface Player extends SldpPlayer {
  isReady?: boolean
  stop: Function
  start: Function
  play: Function
  pause: Function
  setVolume: Function
  setStreamURL: Function
  setCallbacks: Function
  changeDisplayRatio?: Function
  requestFullscreen: Function
}
